import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useState } from "react";
import { Button, Badge } from "reactstrap";

interface Props {
    data: string | undefined
}

const CopyData = ({ data }: Props) => {

    const [isVisible, setisVisible] = useState<boolean>(true);

    const copyOnClick = () => {

        if (data) {

            navigator.clipboard.writeText(data!);

            setisVisible(false);

            setTimeout(() => {
                setisVisible(true);
            }, 3000);
        }
    }

    return (
        <>
            {isVisible &&
                <Button color='link' onClick={(copyOnClick)} aria-label="Copy to clipboard" className="py-0 px-2 lh-1">
                    <FontAwesomeIcon icon="copy" size="lg" />
                </Button>
            }
            {!isVisible &&
                <Badge color="success"
                    pill
                    className="mx-2">
                    Copied!</Badge>
            }
        </>
    );
};

export default CopyData;